import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/modern/utils"

const inputVariants = cva(
  "flex w-full rounded-md text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-base",
  {
    variants: {
      variant: {
        default: "border border-input bg-card",
        ghost: "border-0 bg-transparent",
        outline: "border border-input bg-transparent",
        background: "border border-input bg-background"
      },
      inputSize: {
        default: "h-swivu-input px-3 py-2",
        selectTrigger: "h-swivu-input px-3 py-2 text-sm",
        sm: "h-9 px-4 py-2",
        xs: "h-auto p-0 focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:outline-none",
      }
    },
    defaultVariants: {
      variant: "default",
      inputSize: "default"
    }
  }
)

export interface InputProps
  extends React.ComponentProps<"input">,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant, inputSize, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariants({ variant, inputSize, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
